import { combineReducers } from 'redux';
import diagram from './diagram';
import main from './main';
import canvas from './canvas';
import auth from './auth';
import notify from './notify';
import workspace from './workspace';
import invitation from './invitation';
import socket from './socket';
import collab from './collab';
import notifications from './notifications';
import preferences from './preferences';

const rootReducer = combineReducers({
    diagram,
    main,
    canvas,
    auth,
    notify,
    workspace,
    invitation,
    socket,
    collab,
    notifications,
    preferences,
});

export default rootReducer;
